import { createContentPropTypes } from '../../helpers/content';

const tableHeader = [
	{ title: 'Payee Name', path: ['name'] },
	{ title: 'Payment Reference', path: ['reference'] },
	{ title: 'Payee Sort Code', path: ['sort_code'] },
	{ title: 'Payee Account Number', path: ['account_number'] },
	{ title: 'Amount', path: ['amount'] },
	{ title: 'Account Code', path: ['acc_code'] },
	{ title: 'Transaction Code', path: ['txn_code'] },
];
const uploadErrorFileType = {
	subHeader: 'We only import files that are in .txt or .csv format.',
	footer: 'Please use the instructions to help you create the right file format and try again.',
	panelHeader: 'The problem begins in',
	tableHeader,
};
const uploadErrorMaxRecords = {
	subHeader: 'Your file has more than [[limit]] entries.',
	footer: 'Please remove some entries and try again. You can upload any extra entries you need in another file.',
	panelHeader: 'The problem begins in',
	tableHeader,
};
const uploadErrorStructureError = {
	subHeader:
		'Something is wrong with how the entries are saved. For example, there may more than one entry per line or missing commas.',
	footer: 'Use the instructions and example to help you fix any problems in the file and try again.',
	panelHeader: 'The problem begins in',
	tableHeader,
};
const uploadErrorParseError = {
	subHeader:
		'Something is wrong with the format or length of information in the entries. For example, amounts that have unexpected letters or spaces. or references that are too long.',
	footer: 'Use the instructions and example to help you fix any problems in the file and try again.',
	panelHeader: 'The problem begins in',
	tableHeader,
};
const uploadErrorMinRecords = {
	footer: 'Use the instructions and example to help you set up the file and try again.',
};

export default {
	uploadErrorFileType,
	uploadErrorMaxRecords,
	uploadErrorStructureError,
	uploadErrorParseError,
	uploadErrorMinRecords,
};

export const contentPropTypes = createContentPropTypes(uploadErrorFileType);
